import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { TbEye } from "react-icons/tb";
import ViewUser from "../../Package/Assets/ViewModel";
const EditForm = ({ user, onClose, onEdit }) => {
  const navigate = useNavigate();

    const [packageData, setPackageData] = useState([]);
          const [viewUserModel, setViewUserModel] = useState(false);
          const [itemToView, setItemToView] = useState(null);
  const [formData, setFormData] = useState({
    id: null,
    name: "",
    email: "",
    schoolName: "",
    schoolCode: "",
    website: "",
    designation:"Principal",
    phone: "",
    city: "",
    state:"",
    pincode:"",
    url:"",
    logo: null,
  });
const userRole = localStorage.getItem("UserRole");
const Auth = localStorage.getItem("authToken");
  useEffect(() => {
    if (user) {

      fetchPackageData();





      setFormData({
        id: user.id || null,
        name: user.name || "",
        email: user.email || "",
        schoolName: user.schoolName || "",
        schoolCode: user.schoolCode || "",
        website: user.website || "",
        designation: user.designation || "Principal",
        phone: user.phone || "",
        city: user.city || "",
        state:  user.state || "",
        pincode: user.pincode || "",
        packageId:user.packageId || "",
        url: user.url || ""

      });
    }
  }, [user]);


  const fetchPackageData = async () => {
    try {
      const response = await fetch("https://support.ace-school-backend.serverscripts.in/api/v1/admin/package/view", {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${Auth}`
        },
      });

      
      
      const result = await response.json();
      if (!result.success) throw new Error("Failed to fetch form data");
      setPackageData(result.data || []);
    } catch (err) {
      console.error("Package data fetch error:", err);
    }
  };

  const handleSubmit = () => {
    if (!formData.name || !formData.schoolName) {
      alert("Name and School Name are required");
      return;
    }

    if (formData.phone && formData.phone.length !== 10) {
      alert("Phone must be 10 digits");
      return;
    }

    if (onEdit) {
      console.log("Submitting form with data:", formData);
      const data = new FormData();

      Object.keys(formData).forEach((key) => {
        if (formData[key] !== null) {
          data.append(key, formData[key]);
        }
      });

      onEdit(data);
    }
  };
const handleChange = async (e) => {
  const { name, value } = e.target;

  if (name === "phone" && (!/^\d*$/.test(value) || value.length > 10)) return;
  if (name === "pincode" && (!/^\d*$/.test(value) || value.length > 6)) return;

  setFormData((prev) => ({
    ...prev,
    [name]: value,
  }));

  if (name === "pincode" && value.length < 6) {
    setFormData((prev) => ({
      ...prev,
      city: "",
      state: "",
    }));
    return;
  }

  if (name === "pincode" && value.length === 6) {
    try {
      const res = await fetch(`https://api.postalpincode.in/pincode/${value}`);
      const data = await res.json();

      if (data[0].Status === "Success") {
        const postOffice = data[0].PostOffice[0];

        setFormData((prev) => ({
          ...prev,
          city: postOffice.District,
          state: postOffice.State,
        }));
      } else {
        setFormData((prev) => ({
          ...prev,
          city: "",
          state: "",
        }));
        toast.error("Invalid Pincode");
      }
    } catch (error) {
      console.error("Pincode fetch error:", error);
      toast.error("Failed to fetch location");
    }
  }
};

        const handleViewClick = (item) => {
      setItemToView(item);
      setViewUserModel(true);
    };



        const cancelView = () => {
      setViewUserModel(false);
      setItemToView(null);
    };
    const handleFileChange = (e) => {
  setFormData((prev) => ({
    ...prev,
    logo: e.target.files[0],
  }));
};

  return (
    <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-lg p-6">
        
        <div className="flex justify-between items-center border-b pb-3 mb-4">
          <h2 className="text-xl font-semibold text-gray-800">Update school details</h2>
          <button onClick={onClose} className="text-gray-500 hover:text-gray-800 text-lg">
            ✕
          </button>
        </div>

        <div className="space-y-4 max-h-[70vh] overflow-y-auto">
          {Number(userRole) < 3 && (
            <>
            <div>
              <label className="block font-semibold text-gray-700">User Name</label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter full name"
                className="w-full border rounded-md px-3 py-2 mt-1"
                disabled
              />
            </div>
            <div>
                <label className="labelStyle">Designation</label>
                <select
                  name="designation"
                  value={formData.designation}
                  onChange={handleChange}
                  className="inputStyle"
                  defaultValue="Principal"
                >
                  <option value="" disabled>Select designation</option>
                  <option value="Principal">Principal</option>
                  <option value="Vice Principal">Vice Principal</option>
                  <option value="Technical Staff">Technical Staff</option>
                  <option value="School Staff">School Staff</option>
                </select>
            </div>

            <div>
              <label className="block font-semibold text-gray-700">School Name</label>
              <input
                type="text"
                name="schoolName"
                value={formData.schoolName}
                onChange={handleChange}
                placeholder="Enter School name"
                className="w-full border rounded-md px-3 py-2 mt-1"
                disabled={Number(userRole) > 3}
              />
            </div>
            <div>
              <label className="block font-semibold text-gray-700">School Code *</label>
              <input
                type="text"
                name="schoolCode"
                value={formData.schoolCode}
                onChange={handleChange}
                placeholder="Enter School Code"
                className="w-full border rounded-md px-3 py-2 mt-1"
                readOnly
              />
            </div>
            <div>
                <label className="labelStyle">School Website(url)</label>
                <input
                  name="website"
                  value={formData.website}
                  placeholder="Enter school website (url)"
                  onChange={handleChange}
                  className="inputStyle"
                />
            </div>
          
          
          <div>
            <label className="block font-semibold text-gray-700">Email</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email"
              className="w-full border rounded-md px-3 py-2 mt-1"
              disabled
            />
          </div>

          <div>
              <label className="block font-semibold text-gray-700">Pincode</label>
              <input
                type="text"
                name="pincode"
                value={formData.pincode}
                onChange={handleChange}
                placeholder="Enter pincode"
                className="w-full border rounded-md px-3 py-2 mt-1"
                disabled={Number(userRole) > 3}
              />
            </div>
          
            <div>
              <label className="block font-semibold text-gray-700">City</label>
              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="Enter city"
                className="w-full border rounded-md px-3 py-2 mt-1"
                disabled={Number(userRole) > 3}
                readOnly
              />
            </div>

            <div>
              <label className="block font-semibold text-gray-700">State</label>
              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                placeholder="Enter state"
                className="w-full border rounded-md px-3 py-2 mt-1"
                disabled={Number(userRole) > 3}
                readOnly
              />
            </div>
          
            

          

          <div>
            <label className="block font-semibold text-gray-700">Phone No.</label>
            <input
              type="text"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="Enter 10 digit phone"
              maxLength={10}
              className="w-full border rounded-md px-3 py-2 mt-1"
              disabled={Number(userRole) > 3}
            />
          </div>

          {/* <div>
            <label className="labelStyle">Package</label>

            <div className="space-y-2 border rounded-md p-2 max-h-60 overflow-y-auto">

              {packageData.length > 0 ? (
                <>
                  {packageData.map((pkg, index) => (
                    <div
                      key={index}
                      className="flex items-center justify-between border rounded-md px-3 py-2 hover:bg-gray-50"
                    >

                      <div
                        onClick={() =>
                          setFormData((prev) => ({
                            ...prev,
                            packageId: pkg.id,
                          }))
                        }
                        className={`cursor-pointer flex-1 ${
                          formData.packageId === pkg.id
                            ? "text-blue-600 font-semibold"
                            : "text-gray-700"
                        }`}
                      >
                        {pkg.packageName}
                      </div>

                      <button
                        type="button"
                        onClick={() => handleViewClick(pkg)}
                        className="text-blue-500 hover:text-blue-700"
                      >
                        <TbEye size={20} />
                      </button>

                    </div>
                  ))}

                  <div
                    onClick={() => {
                      navigate("/view-package");
                    }}
                    className="border border-dashed rounded-md px-3 py-2 text-center text-green-600 font-medium cursor-pointer hover:bg-green-50"
                  >
                    + Add Package
                  </div>
                </>
              ) : (
                <div className="text-gray-500 text-sm text-center py-3">
                  No packages available
                </div>
              )}
            </div>
          </div> */}






          </>



)}
          
          <div>
            <label className="block font-semibold text-gray-700">Front-end URL</label>
            <input
              type="url"
              name="url"
              value={formData.url}
              onChange={handleChange}
              placeholder="https://example.com"
              className="w-full border rounded-md px-3 py-2 mt-1"
            />
          </div>
          <div>
            <label className="block font-semibold text-gray-700">Select School Logo</label>
            <input
              type="file"
              name="logo"
              accept="image/*"
              onChange={handleFileChange}
              className="w-full border rounded-md px-3 py-2 mt-1"
            />
          </div>

        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-300 text-gray-800 rounded-md hover:bg-gray-400"
          >
            Cancel
          </button>

          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            Submit
          </button>
        </div>
      </div>
      {viewUserModel && (
        <ViewUser
          user={itemToView}
          onClose={cancelView}
        />
      )}
    </div>
  );
};

export default EditForm;